import React, { useState, useRef, useEffect } from "react";
import "./NavBar.css";
import { Link, useNavigate } from "react-router-dom";
import { FaCartArrowDown, FaShippingFast } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import Profile from "../Profile/Profile";
import { RiAlignItemLeftLine } from "react-icons/ri";
import { Logo1, Logo2 } from "../../Assests/Assests";
import { TbListCheck } from "react-icons/tb";
import MarqueeBanner from "./MarqueeBanner";



const NavBar = () => {
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const profileRef = useRef(null);
  const navigate = useNavigate();

  const toggleProfile = (event) => {
    event.stopPropagation(); // Prevent click from reaching document
    setIsProfileVisible((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setIsProfileVisible(false);
    }
  };

  useEffect(() => {
    if (isProfileVisible) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isProfileVisible]);

  const handleProtectedNavigation = (path) => {
    const token = localStorage.getItem("userToken");
    if (!token) {
      navigate("/login");
    } else {
      navigate(path);
    }
  };

  return (
    <div className="navbar-container">
      <MarqueeBanner />
      <nav className="navbar">
        <div className="navbar-section">
          {/* Logo1 removed — replaced by sub-nav below */}
        </div>
        <div className="navbar-section">
          <Link to="/">
            <img src={Logo2} alt="Main Logo" className="main-logo" />
          </Link>
        </div>
        <div className="navbar-section">
          <div className="navbar-icons">
            <button className="icon-button nav-tip" data-tip="Orders" onClick={() => handleProtectedNavigation("/order-history")}>
              <TbListCheck />
            </button>
            <button className="icon-button nav-tip" data-tip="Cart" onClick={() => handleProtectedNavigation("/cart")}>
              <FaCartArrowDown />
            </button>
            <button className="icon-button nav-tip" data-tip="Profile" onClick={toggleProfile}>
              <CgProfile />
            </button>
          </div>
        </div>
      </nav>

      <div className="subnav">
        <Link to="/products-collection" className="subnav-link">Collections</Link>
        <Link to="/newproduct" className="subnav-link">All Products</Link>
        <Link to="/comiingsoon" className="subnav-link">Spectacle</Link>
        <Link to="/About" className="subnav-link">About</Link>
      </div>

      {isProfileVisible && (
        <div className="user-profilecard" ref={profileRef}>
          <Profile />
        </div>
      )}
    </div>
  );
};

export default NavBar;
